import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import { Container } from '../../../assets/styles/GlobalStyle'
import PageHeader from '../../../components/PageHeader'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import Title from '../../../components/v2/Title'
import api from '../../../api'
import Loader from '../../../components/Loader'
import { AppState } from '../../../store/appSlice'
import { useAppSelector } from '../../../store'
import { IntTplState, setFilterField, setUserField } from '../../../store/internationalTplSlice'
import { useDispatch } from 'react-redux'
import { useInternationalTplPages } from './useInternationalTplPages'
import { useInternationalTplProgress } from './useInternationalTplProgress'

const InternationalTplCountry = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  const { filter } = useAppSelector((data: { internationalTpl: IntTplState }) => data.internationalTpl)

  const { data, isLoading } = api.useGetIntTplCountriesQuery('international-tpl')

  // Use the hook to get pages and page data from Redux
  const { pages, pageData, isLoading: isPagesLoading } = useInternationalTplPages()
  const pageInfo = pageData['international-tpl-which-country-to-drive']

  // Use progress hook to update passedCount and totalCount
  const { totalCount, passedCount, pages: progressPages } = useInternationalTplProgress()

  // Use pages from progress hook if available, otherwise from pages hook
  const displayPages = progressPages.length > 0 ? progressPages : pages

  return isLoading || isPagesLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <PageHeader total={totalCount} passed={passedCount} pages={displayPages} />
      <Container>
        <Content>
          <Title text={pageInfo?.translations?.[lang]?.title} />
          <Block>
            {data?.map((item) => (
              <HorizontalCard
                className="horizontal-card"
                key={item.id}
                title={item?.translations?.[lang]?.name}
                imgUrl={item?.iconUrl || ''}
                selected={item?.isoCode === filter?.isoCode}
                onClick={() => {
                  dispatch(
                    setFilterField({
                      fieldName: 'isoCode',
                      fieldValue: item?.isoCode,
                    }),
                  )

                  dispatch(
                    setUserField({
                      fieldName: 'clientType',
                      fieldValue: '',
                    }),
                  )

                  dispatch(
                    setUserField({
                      fieldName: 'clientDocTypeId',
                      fieldValue: undefined,
                    }),
                  )

                  dispatch(
                    setUserField({
                      fieldName: 'clientTypeId',
                      fieldValue: '',
                    }),
                  )
                }}
              />
            ))}
          </Block>
          <Buttons>
            <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/category')} />
            <NavigationButton
              text={`${t('next')}`}
              buttonType="next"
              disabled={!filter.isoCode}
              onClick={() => navigate('/international-tpl-days')}
            />
          </Buttons>
        </Content>
      </Container>
    </Wrapper>
  )
}

const Content = styled.div`
  margin-top: 40px;
  margin-bottom: 32px;
  z-index: 2;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  ${Responsive.mobile} {
    margin-top: 24px;
  }
`
const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  max-width: 432px;
  width: 100%;
  margin: 0 auto;

  .horizontal-card-content {
    align-items: center;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`

export default InternationalTplCountry
